import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import style from "./CommentForm.module.sass";
import { callApi } from "../../../../helpers";

function CommentForm(props) {
  const { translations, newCommentPath, onSubmit, onCancel, onTypingChange } = props;
  const [text, setText] = useState('');

  const MAX_HEIGHT = 250;

  const onChange = (e) => {
    const textarea = e.target;

    textarea.style.height = "auto";

    if (textarea.scrollHeight > MAX_HEIGHT) {
      textarea.style.height = MAX_HEIGHT + "px";
      textarea.style.overflowY = "auto";
    } else {
      textarea.style.height = textarea.scrollHeight + "px";
      textarea.style.overflowY = "hidden";
    }

    const newValue = textarea.value;
    setText(newValue);

    if (onTypingChange) {
      onTypingChange(newValue.trim().length > 0);
    }
  };

  const onSubmitSuccess = () => {
    setText('');
    onTypingChange(false);
    onSubmit();
  };

  const onClickSubmit = (newValue) => {
    callApi(newCommentPath, "POST", "", onSubmitSuccess, null, null, {
      body: JSON.stringify({ text: text })
    });
  };

  const onClickCancel = () => {
    setText('');
    onTypingChange(false);
    onCancel();
  }

  let rootClass = `${style.CommentForm} ${text.trim().length > 0 ? style.active : ''}`;

  return (
    <div className={rootClass}
      onClick={(e) => e.stopPropagation()}>
      <div className={style.text}>
        <textarea
          id="comment-textarea"
          value={text}
          onChange={onChange}
          placeholder={translations.placeholder}
        // onClick={(e) => e.stopPropagation()}
        />
      </div>
      <div className={style.footer}>
        <div className={style.cancelButton} onClick={onClickCancel}>{translations.actions.cancel}</div>
        <div className={style.submitButton} onClick={onClickSubmit}>{translations.actions.save}</div>
      </div>
    </div>
  );
}

CommentForm.propTypes = {};

CommentForm.defaultProps = {};

export default CommentForm;
